<div [id]="block.blockId" [class]="'z-1 relative ' + (blockClass ? (blockClass + ' ') : '') + theme.current.card + (block.class_overwrite ? (' ' + block.class_overwrite) : '' ) + ' ' + (componentOffset)">
    <div class="container m-auto relative overflow-hidden px-3 lg:px-0">
        <app-seaweed *ngIf="block.background_seaweed" [alignment]="block.seaweed_alignment.value"
                     [theme]="theme"></app-seaweed>

        <div [class]="'relative ' + (container ? 'md:px-6 lg:px-8 xl:!px-42' : '')"
             [ngClass]="{'py-7': theme.theme !== 'light'}">
            <div [class]="'grid grid-nogutter ' + (grid_alignment[block.grid_alignment?.value ?? 'left']) + ' ' + (grid_content_alignment[block.grid_content_alignment?.value ?? 'center'])">
                <div *ngFor="let contentComponent of contentComponents; let odd = odd"
                     [class]="alignment[block.alignment.value][odd ? 'odd' : 'even'] + ' relative flex overflow-hidden'">
                    <app-content [block]="contentComponent" [theme]="theme"></app-content>
                </div>
            </div>
        </div>
    </div>
</div>
